import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
const MATTERS = [{
  label: 'SMSF purchases',
  href: '/smsf-trust-property'
}, {
  label: 'Family and discretionary trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Unit trusts',
  href: '/smsf-trust-property'
}, {
  label: 'Commercial property',
  href: '/commercial-property'
}, {
  label: 'Commercial leases',
  href: '/commercial-property'
}, {
  label: 'Property transfers',
  href: '/property-transfers'
}, {
  label: 'Subdivisions',
  href: '/subdivisions'
}, {
  label: 'Solicitor certificates',
  href: '/solicitor-certificates'
}];
export function ComplexMatters() {
  return <section className="py-20 md:py-28 px-5 md:px-6 bg-ink text-cream" data-id="element-212">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-213">
        <div className="lg:col-span-5" data-id="element-214">
          <p className="text-accent-light font-script text-2xl mb-1" data-id="element-215">
            beyond the basics
          </p>
          <h2 className="font-serif text-3xl md:text-[2.6rem] leading-tight text-cream" data-id="element-216">
            More than standard conveyancing.
          </h2>
          <p className="mt-6 text-lg text-cream/70 leading-relaxed" data-id="element-217">
            Some purchases carry extra moving parts. Complex structures may need
            coordination with your accountant, financial adviser and lender, and
            we work alongside them so nothing falls between the cracks.
          </p>
        </div>

        <div className="lg:col-span-7" data-id="element-218">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-219">
            {MATTERS.map(m => <Link key={m.label} to={m.href} className="group flex items-center justify-between rounded-2xl bg-white/[0.04] border border-white/10 px-5 py-4 transition-colors hover:bg-white/[0.08] hover:border-accent/40" data-id="element-220">
                <span className="text-cream/90" data-id="element-221">{m.label}</span>
                <ArrowRight className="w-4 h-4 text-accent-light opacity-0 -translate-x-1 transition-all group-hover:opacity-100 group-hover:translate-x-0" data-id="element-222" />
              </Link>)}
          </div>
          <p className="mt-5 text-sm text-cream/50" data-id="element-223">
            Note: we coordinate with your advisers but do not provide tax or
            financial advice.
          </p>
        </div>
      </div>
    </section>;
}